import { Card } from 'react-bootstrap';
import { Persona } from 'data/crm/Personas';

interface AboutPersonaCardProps {
  persona: Persona;
  className?: string;
}

const AboutPersonaCard = ({ persona, className }: AboutPersonaCardProps) => {
  return (
    <Card className={className}>
      <Card.Body>
{/*         <h4 className="mb-4">Sobre {persona.nombres}</h4>
 */}        <ul className="list-unstyled mb-0">
          <li className="mb-2"><strong>DNI / ID:</strong> {persona.id}</li>
          <li className="mb-2"><strong>Nombres:</strong> {persona.nombres}</li>
          <li className="mb-2"><strong>Apellido:</strong> {persona.apellido}</li>
          <li className="mb-2">
            <strong>Fecha de Nacimiento:</strong> {persona.Fecha_de_nacimiento ? persona.Fecha_de_nacimiento : 'No registrada'}
          </li>
          <li className="mb-2">
            <strong>Dirección:</strong> {persona.direccion ? persona.direccion : 'No registrada'}
          </li>
          <li className="mb-0">
            <strong>Email:</strong> {persona.email ? persona.email : 'No registrado'}
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default AboutPersonaCard;